__turbopack_context__.v({
  "image": "Image-module-scss-module__Rr4Dbq__image",
});
